import { n as ALLOWED_HTML_TAGS, t as ALLOWED_HTML_ATTRIBUTES } from "./sanitization.mjs";
import { toValue } from "vue";
import xss, { escapeAttrValue } from "xss";

//#region src/htmlUtils.ts
function sanitizeHtml(dirtyHtml) {
	return xss(dirtyHtml, {
		onTagAttr: (tag, name, value) => {
			if (tag === "img" && name === "src") {
				const isStaticImageFile = value.split("#")[0].match(/\.(jpeg|jpg|gif|png|webp)$/) !== null && value.startsWith("/static/");
				if (!value.startsWith("https://") && !isStaticImageFile) return "";
			}
			if (ALLOWED_HTML_ATTRIBUTES.includes(name) || name.startsWith("data-")) {
				if (name === "href" && !value.match(/^https?:\/\//) && !value.startsWith("/")) return "";
				return `${name}="${escapeAttrValue(value)}"`;
			}
		},
		onTag: (tag) => {
			if (!ALLOWED_HTML_TAGS.includes(tag)) return "";
		}
	});
}
const SAFE_OPEN_PROTOCOLS = ["http:", "https:"];
/**
* Opens a URL in a new tab, but only when it resolves to an http(s) protocol.
* Persisted, untrusted values (e.g. resource locator URLs) can carry schemes
* like `javascript:` or `data:`, so anything else is dropped. Always opens with
* `noopener,noreferrer` so the new tab cannot reach back to the opener window.
*/
function openSafeUrl(url) {
	let protocol;
	try {
		protocol = new URL(url, window.location.origin).protocol;
	} catch {
		return;
	}
	if (SAFE_OPEN_PROTOCOLS.includes(protocol)) window.open(url, "_blank", "noopener,noreferrer");
}
/**
* Checks if the input is a string and sanitizes it by removing or escaping harmful characters,
* returning the original input if it's not a string.
*/
const sanitizeIfString = (message) => {
	if (typeof message === "string") return sanitizeHtml(message);
	return message;
};
const capitalizeFirstLetter = (text) => {
	return text.charAt(0).toUpperCase() + text.slice(1);
};
const getBannerRowHeight = async () => {
	return await new Promise((resolve) => {
		setTimeout(() => {
			resolve(document.getElementById("banners")?.clientHeight ?? 0);
		}, 0);
	});
};
function isOutsideSelected(el) {
	const selection = document.getSelection();
	if (!selection?.anchorNode || !selection.focusNode || !el) return false;
	return !el.contains(selection.anchorNode) && !el.contains(selection.focusNode) && (selection.anchorNode !== selection.focusNode || selection.anchorOffset !== selection.focusOffset);
}
let scrollbarWidth;
function getScrollbarWidth() {
	if (scrollbarWidth !== void 0) return scrollbarWidth;
	const outer = document.createElement("div");
	const inner = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.overflow = "scroll";
	document.body.appendChild(outer);
	outer.appendChild(inner);
	scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
	outer.parentElement?.removeChild(outer);
	return scrollbarWidth;
}
function isEventTargetContainedBy(eventTarget, maybeContainer) {
	return !!(eventTarget instanceof Node && toValue(maybeContainer)?.contains(eventTarget));
}

//#endregion
export { capitalizeFirstLetter, getBannerRowHeight, getScrollbarWidth, isEventTargetContainedBy, isOutsideSelected, openSafeUrl, sanitizeHtml, sanitizeIfString };
//# sourceMappingURL=htmlUtils.mjs.map